<section id="contacto">
  <div class="formulario-contenido">
    <div class="container my-5">
      <div class="container py-5">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div class="card shadow">
              <div class="card-header text-white text-center">
                <h3>Formulario de Contacto</h3>
              </div>
              <div class="card-body p-4">
                <!-- Formulario con ngForm -->
                <form #formulario="ngForm" (ngSubmit)="enviarFormulario(formulario)">
                  <!-- Campo Nombre -->
                  <div class="mb-3">
                    <label for="nombre" class="form-label">Nombre completo</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nombre"
                      name="nombre"
                      ngModel
                      placeholder="Ingresa tu nombre"
                      required
                    />
                    <div
                      *ngIf="formulario.submitted && !formulario.controls['nombre']?.valid"
                      class="text-danger"
                    >
                      El nombre es obligatorio
                    </div>
                  </div>

                  <!-- Campo Teléfono -->
                  <div class="mb-3">
                    <label for="telefono" class="form-label">Teléfono</label>
                    <input
                      type="tel"
                      class="form-control"
                      id="telefono"
                      name="telefono"
                      ngModel
                      placeholder="Ingresa tu teléfono"
                      pattern="^[0-9]{7,15}$"
                      required
                    />
                    <div
                      *ngIf="formulario.submitted && !formulario.controls['telefono']?.valid"
                      class="text-danger"
                    >
                      Ingresa un teléfono válido (solo números, 7-15 dígitos)
                    </div>
                  </div>

                  <!-- Campo Mensaje -->
                  <div class="mb-3">
                    <label for="mensaje" class="form-label">Mensaje</label>
                    <textarea
                      class="form-control"
                      id="mensaje"
                      name="mensaje"
                      ngModel
                      rows="4"
                      placeholder="Escribe tu mensaje aquí..."
                      required
                    ></textarea>
                    <div
                      *ngIf="formulario.submitted && !formulario.controls['mensaje']?.valid"
                      class="text-danger"
                    >
                      El mensaje es obligatorio
                    </div>
                  </div>

                  <!-- Botón de enviar -->
                  <div class="d-grid">
                    <button type="submit" class="btn text-white">Enviar Mensaje</button>
                  </div>
                </form>

                <!-- Mensajes de estado -->
                <div *ngIf="enviado" class="alert alert-success mt-3">
                  ¡Tu mensaje fue enviado con éxito!
                </div>
                <div *ngIf="error" class="alert alert-danger mt-3">
                  Hubo un error al enviar el mensaje. Intenta de nuevo.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
